module.exports = __webpack_public_path__ + "img/project13_1.jpg.89c6f1ff.webp";